import React, { ChangeEvent } from "react";
import styles from "./ImagesBlock.module.scss";

interface ImagesBlockProps {
    images: (File | string | null)[];
    onChange: (file: File, index: number) => void;
    onRemove: (index: number) => void;
}

interface ImageSlotProps {
    image: File | string | null;
    onChange: (file: File) => void;
    onRemove: () => void;
    large?: boolean;
}

const ImageSlot: React.FC<ImageSlotProps> = ({ image, onChange, onRemove, large }) => {
    const handleSelect = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files[0]) {
            onChange(e.target.files[0]);
        }
    };

    let previewUrl: string | null = null;
    if (image instanceof File) {
        previewUrl = URL.createObjectURL(image);
    } else if (typeof image === "string") {
        previewUrl = image;
    }

    return (
        <div className={`${large ? styles.large : styles.small} ${styles.slot}`}>
            {previewUrl ? (
                <div className={styles.imageWrapper}>
                    <img src={previewUrl} alt="preview" className={styles.img} />
                    <button className={styles.removeBtn} onClick={onRemove}>
                        <svg
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <rect
                                width="32"
                                height="32"
                                rx="12"
                                fill="#1B1D1D"
                                fillOpacity="0.4"
                            />
                            <path
                                d="M23.001 21.9438C23.2939 22.2367 23.2939 22.7115 23.001 23.0044C22.7081 23.2973 22.2333 23.2973 21.9404 23.0044L15.999 17.0631L10.0577 23.0044C9.76478 23.2973 9.28991 23.2973 8.99701 23.0044C8.70412 22.7115 8.70412 22.2367 8.99701 21.9438L14.9384 16.0024L8.99758 10.0616C8.70469 9.76869 8.70469 9.29381 8.99758 9.00092C9.29047 8.70803 9.76535 8.70803 10.0582 9.00092L15.999 14.9417L21.9398 9.00092C22.2327 8.70803 22.7076 8.70803 23.0005 9.00092C23.2934 9.29382 23.2934 9.76869 23.0005 10.0616L17.0597 16.0024L23.001 21.9438Z"
                                fill="white"
                            />
                        </svg>
                    </button>
                </div>
            ) : (
                <label className={styles.addBtn}>
                    <input type="file" hidden accept="image/*" onChange={handleSelect} />
                    <div className={styles.plus}>+</div>
                </label>
            )}
        </div>
    );
};

export const ImagesBlock: React.FC<ImagesBlockProps> = ({
                                                            images,
                                                            onChange,
                                                            onRemove,
                                                        }) => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.title}>Изображения</div>
            <div className={styles.grid}>
                <ImageSlot
                    image={images[0]}
                    onChange={(file) => onChange(file, 0)}
                    onRemove={() => onRemove(0)}
                    large
                />

                <div className={styles.smallGrid}>
                    {Array.from({ length: 4 }).map((_, col) => (
                        <div className={styles.smallColumn} key={col}>
                            {Array.from({ length: 2 }).map((_, row) => {
                                const index = 1 + col * 2 + row;
                                return (
                                    <ImageSlot
                                        key={index}
                                        image={images[index]}
                                        onChange={(file) => onChange(file, index)}
                                        onRemove={() => onRemove(index)}
                                    />
                                );
                            })}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
